import './vendor.ts';

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { Ng2Webstorage } from 'ng2-webstorage';

import { BnbaccessBoSharedModule, UserRouteAccessService } from './shared';
import { BnbaccessBoHomeModule } from './home/home.module';
import { BnbaccessBoAdminModule } from './admin/admin.module';
import { BnbaccessBoAccountModule } from './account/account.module';
import { BnbaccessBoEntityModule } from './entities/entity.module';

import { LayoutRoutingModule } from './layouts';
import { customHttpProvider } from './blocks/interceptor/http.provider';
import { PaginationConfig } from './blocks/config/uib-pagination.config';

import {
    JhiMainComponent,
    NavbarComponent,
    FooterComponent,
    ProfileService,
    PageRibbonComponent,
    ActiveMenuDirective,
    ErrorComponent
} from './layouts';


@NgModule({
    imports: [
        BrowserModule,
        LayoutRoutingModule,
        Ng2Webstorage.forRoot({ prefix: 'jhi', separator: '-'}),
        BnbaccessBoSharedModule,
        BnbaccessBoHomeModule,
        BnbaccessBoAdminModule,
        BnbaccessBoAccountModule,
        BnbaccessBoEntityModule
    ],
    declarations: [
        JhiMainComponent,
        NavbarComponent,
        ErrorComponent,
        PageRibbonComponent,
        ActiveMenuDirective,
        FooterComponent
    ],
    providers: [
        ProfileService,
        { provide: Window, useValue: window },
        { provide: Document, useValue: document },
        customHttpProvider(),
        PaginationConfig,
        UserRouteAccessService
    ],
    bootstrap: [ JhiMainComponent ]
})
export class BnbaccessBoAppModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/app.module.ts